import { LISTA_ROTAS, SELECIONAR_ROTA, LISTAR_TODAS_TAGS, GET_ROTA_USE, LISTAR_GRUPOS } from './mutation-types'
import rotasHttpService from '../_services/rotasHttpService'

export default {
  listarRotas: async ({ commit }) => {
    try {
      const response = await rotasHttpService.getrotas()
      commit(LISTA_ROTAS, response.data)
    } catch (e) {
      console.log(e)
    }
  },

  selecionarRota: async ({ commit }, _id) => {
    try {
      const response = await rotasHttpService.getrota(_id)
      commit(SELECIONAR_ROTA, response.data)
    } catch (e) {
      console.log(e)
    }
  },

  listarTags: async ({ commit }) => {
    try {
      const response = await rotasHttpService.getTags()
      commit(LISTAR_TODAS_TAGS, response.data)
    } catch (e) {
      console.log(e)
    }
  },

  listarRotaUse: async({ commit }, id) => {
    try {
      const response = await rotasHttpService.getRotaUse(id)
      commit(GET_ROTA_USE, response.data)
    } catch (e) {
      console.log(e)
    }
  },

  listarGruposRotas: async ({ commit }) => {
    try{
      const response = await rotasHttpService.getGrupos()
      commit(LISTAR_GRUPOS, response.data)
    } catch (e) {
      console.log(e)
    }
  }
}
